// extracted by mini-css-extract-plugin
export default {"button":"Button_button__Z5CAW","secondary":"Button_secondary__LMfGQ","small":"Button_small__hxnxB"};